import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import FormContext from '../FormContext';
import { getIsDataDirty } from '../../../features/app/selectors';

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: ({ position }) => theme.spacing(position === 'right' ? 1 : 0),
    marginRight: ({ position }) => theme.spacing(position === 'left' ? 3 : 0)
  }
}));

const Button = ({
  label,
  visible = true,
  startIcon,
  deactivateGlobalButton,
  requireSavedData = false,
  position = 'right',
  color = 'primary',
  onClick,
  btnDisabled
}) => {
  const classes = useStyles({ position });
  const { data } = useContext(FormContext);
  const { formatMessage } = useIntl();
  const isDataDirty = useSelector(getIsDataDirty);
  const disabled = requireSavedData && isDataDirty;
  const displayMessage = deactivateGlobalButton;

  if (!visible) {
    return null;
  }

  function handleClick() {
    onClick(data);
  }

  const tooltipTitle = formatMessage({
    id: 'form.buttonRequireSavedDataTooltip'
  });

  const tooltipForImport = formatMessage({
    id: 'form.importButtonDisabled'
  });

  return (
    <Tooltip
      title={
        (disabled ? tooltipTitle : '') ||
        (displayMessage === true ? tooltipForImport : '')
      }
    >
      <span>
        <MuiButton
          classes={{ root: classes.button }}
          variant="contained"
          color={color}
          startIcon={startIcon}
          disabled={btnDisabled || disabled}
          // importUpdates changes
          // disabled={disabled}
          onClick={handleClick}
        >
          <FormattedMessage id={label} />
        </MuiButton>
      </span>
    </Tooltip>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  startIcon: PropTypes.element,
  requireSavedData: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right']),
  color: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default Button;
